import { networkCall } from "../../../../../utils/network-call/network-call";

export const UserProfileLoader = async () => {
    const getMeResponse = await networkCall('/users/me');
    return { getMeResponse };
};